import { useMemo } from 'react';
import { getHintForPage } from '../utils/hintEngine';

/**
 * Hook para obter dica contextual para a página atual
 * 
 * @param {string} pageName - Nome da página (dashboard, professionals, services, places, schedules)
 * @param {object} pageData - Dados do escopo da página (stats, items, etc.)
 * @returns {object|null} - Objeto hint { type, message, action } ou null
 * 
 * @example
 * // Em DashboardPage
 * const hint = useContextualHint('dashboard', { stats });
 * 
 * @example
 * // Em ProfessionalsPage
 * const hint = useContextualHint('professionals', { items: professionals });
 * 
 * @example
 * // Em PlacesPage (normalizado)
 * const hint = useContextualHint('places', { places, data: normalizedData });
 */
export const useContextualHint = (pageName, pageData) => {
  const hint = useMemo(() => {
    return getHintForPage(pageName, pageData);
  }, [pageName, pageData]);

  return hint;
};
